import { useLocation } from 'react-router-dom';
import { useIsomorphicLayoutEffect } from 'usehooks-ts';

// When a url hash/anchor is present, this scrolls to it after the page renders

export default function useScrollToAnchor(isLoading) {
  const location = useLocation();

  useIsomorphicLayoutEffect(() => {
    const anchorElement = document.getElementById(location.hash.replace('#', ''));
    if (!isLoading && !!location.hash && anchorElement) {
      anchorElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.hash, isLoading]);
}
